import { Component } from '@angular/core';
import { MediaCardsSectionComponent } from '../media-cards-section/media-cards-section.component';

@Component({
  selector: 'ft-media-cards-index',
  templateUrl: './media-cards-index.component.html',
})
export class MediaCardsIndexComponent extends MediaCardsSectionComponent {}
